import { Font } from "@react-pdf/renderer";
import Poppins from "assets/fonts/Poppins-Regular.ttf";
import PoppinsItalic from "assets/fonts/Poppins-Italic.ttf";
import PoppinsLight from "assets/fonts/Poppins-Light.ttf";
import PoppinsMedium from "assets/fonts/Poppins-Medium.ttf";
import PoppinsMediumItalic from "assets/fonts/Poppins-MediumItalic.ttf";
import PoppinsBold from "assets/fonts/Poppins-Bold.ttf";
import PoppinsBoldItalic from "assets/fonts/Poppins-BoldItalic.ttf";

Font.register({
  family: "Poppins",
  src: Poppins,
  fontStyle: "normal",
  fontWeight: "normal",
  fonts: [
    {
      src: PoppinsLight,
      fontStyle: "normal",
      fontWeight: "light",
    },
    {
      src: PoppinsItalic,
      fontStyle: "italic",
      fontWeight: "normal",
    },
    {
      src: PoppinsMedium,
      fontStyle: "normal",
      fontWeight: "medium",
    },
    {
      src: PoppinsMediumItalic,
      fontStyle: "italic",
      fontWeight: "medium",
    },
    {
      src: PoppinsBold,
      fontStyle: "normal",
      fontWeight: "bold",
    },
    {
      src: PoppinsBoldItalic,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
});
